import { render, staticRenderFns } from "./Modify.vue?vue&type=template&id=6c8f7090"
import script from "./Modify.vue?vue&type=script&lang=js"
export * from "./Modify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports